// ModaisNivel.jsx
import React from 'react';
import { obterImagemAdepto, obterImagemJogador } from './tabelaNiveis';
import InfoNiveis from './InfoNiveis';
import ConquistasFuturas from './ConquistasFuturas';

import bronzeAdepto from './assets/niveis/bronze_adepto.png';
import prataAdepto from './assets/niveis/prata_adepto.png';
import ouroAdepto from './assets/niveis/ouro_adepto.png';
import diamanteAdepto from './assets/niveis/diamante_adepto.png';
import campeaoAdepto from './assets/niveis/campeao_adepto.png';

import bronzeJogador from './assets/niveis/bronze_jogador.png';
import prataJogador from './assets/niveis/prata_jogador.png';
import ouroJogador from './assets/niveis/ouro_jogador.png';
import diamanteJogador from './assets/niveis/diamante_jogador.png';
import campeaoJogador from './assets/niveis/campeao_jogador.png';

export function ModalAdepto({ aberta, aoFechar, nivel, xp }) {
  const [infoAberta, setInfoAberta] = React.useState(false);

  if (!aberta) return null;
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 99999, backdropFilter: 'blur(5px)' }}>
      <div style={{ background: '#0d0d0d', border: '2px solid #FF007F', borderRadius: '16px', width: '85%', maxWidth: '340px', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', boxShadow: '0 0 25px rgba(255, 0, 127, 0.3)', textAlign: 'center', position: 'relative' }}>
        
        <button 
          onClick={() => setInfoAberta(true)} 
          style={{ position: 'absolute', top: '15px', right: '15px', background: 'none', border: 'none', color: '#FF007F', fontSize: '1.2rem', fontWeight: 'bold', cursor: 'pointer', textShadow: '0 0 5px #FF007F' }}
        >
          ❓
        </button>

        <h2 style={{ color: '#FF007F', margin: '0 0 5px 0', fontSize: '18px', fontWeight: '950', textShadow: '0 0 5px #FF007F' }}>BANCADA DE ADEPTOS 📢</h2>
        <p style={{ color: '#aaa', fontSize: '11px', margin: '0 0 20px 0' }}>O teu estatuto de apoio no Estádio</p>
        <div style={{ width: '120px', height: '120px', borderRadius: '50%', overflow: 'hidden', border: '3px solid #FF007F', marginBottom: '15px' }}>
          <img src={obterImagemAdepto(nivel)} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Adepto" />
        </div>
        <div style={{ fontSize: '22px', fontWeight: '950', color: '#fff', marginBottom: '5px' }}>Nível {nivel}</div>
        <div style={{ color: '#eee', fontSize: '12px', marginBottom: '15px' }}>Pontos de Apoio: <span style={{ color: '#FF007F', fontWeight: 'bold' }}>{xp} XP</span></div>
        
        <div style={{ background: 'rgba(255, 0, 127, 0.1)', border: '1px dashed #FF007F', borderRadius: '8px', padding: '10px', width: '100%', boxSizing: 'border-box', marginBottom: '15px' }}>
          <div style={{ color: '#FF007F', fontSize: '11px', fontWeight: '900', marginBottom: '6px' }}>PRIVILÉGIO ATUAL:</div>
          <div style={{ color: '#fff', fontSize: '11px', lineHeight: '1.4', textAlign: 'left' }}>
            {nivel >= 1 && nivel <= 10 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={bronzeAdepto} style={{ width: '24px', height: '24px', borderRadius: '50%' }} alt="b" />
                <span><strong>Lv. 1 ao 10: Amador (Bronze)</strong> ➔ Cachecol metálico de bronze com luzes suaves.</span>
              </div>
            )}
            {nivel >= 11 && nivel <= 20 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={prataAdepto} style={{ width: '24px', height: '24px', borderRadius: '50%' }} alt="s" />
                <span><strong>Lv. 11 ao 20: Convocado (Prata)</strong> ➔ Cachecol de prata polida, néon rosa e azul elétrico.</span>
              </div>
            )}
            {nivel >= 21 && nivel <= 35 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={ouroAdepto} style={{ width: '24px', height: '24px', borderRadius: '50%' }} alt="g" />
                <span><strong>Lv. 21 ao 35: Titular (Ouro)</strong> ➔ Cachecol de ouro puro brilhante com reflexos ricos e néon âmbar.</span>
              </div>
            )}
            {nivel >= 36 && nivel <= 50 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={diamanteAdepto} style={{ width: '24px', height: '24px', borderRadius: '50%' }} alt="d" />
                <span><strong>Lv. 36 ao 50: Capitão (Diamante)</strong> ➔ Cachecol de cristal premium com néon cyan e roxo.</span>
              </div>
            )}
            {nivel >= 51 && nivel <= 70 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={campeaoAdepto} style={{ width: '24px', height: '24px', borderRadius: '50%' }} alt="c" />
                <span><strong>Lv. 51 ao 70: Lenda (Campeão)</strong> ➔ Cachecol majestoso com fogo néon, raios e coroa imperial.</span>
              </div>
            )}
          </div>
        </div>

        <ConquistasFuturas nivelAtual={nivel} tipo="adepto" />

        <button onClick={aoFechar} style={{ background: '#FF007F', color: 'black', border: '2px solid black', borderRadius: '8px', padding: '8px 24px', fontSize: '12px', fontWeight: '950', cursor: 'pointer', boxShadow: '2px 2px 0px black', width: '100%' }}>VOLTAR AO CAMPO ⚽</button>
      </div>

      <InfoNiveis isOpen={infoAberta} onClose={() => setInfoAberta(false)} />
    </div>
  );
}

export function ModalJogador({ aberta, aoFechar, nivel, xp }) {
  const [infoAberta, setInfoAberta] = React.useState(false);

  if (!aberta) return null;
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 99999, backdropFilter: 'blur(5px)' }}>
      <div style={{ background: '#0d0d0d', border: '2px solid #39FF14', borderRadius: '16px', width: '85%', maxWidth: '340px', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', boxShadow: '0 0 25px rgba(57, 255, 20, 0.3)', textAlign: 'center', position: 'relative' }}>
        
        <button 
          onClick={() => setInfoAberta(true)} 
          style={{ position: 'absolute', top: '15px', right: '15px', background: 'none', border: 'none', color: '#39FF14', fontSize: '1.2rem', fontWeight: 'bold', cursor: 'pointer', textShadow: '0 0 5px #39FF14' }}
        >
          ❓
        </button>

        <h2 style={{ color: '#39FF14', margin: '0 0 5px 0', fontSize: '18px', fontWeight: '950', textShadow: '0 0 5px #39FF14' }}>BALNEÁRIO DE CRAQUES 🏃</h2>
        <p style={{ color: '#aaa', fontSize: '11px', margin: '0 0 20px 0' }}>O teu estatuto de performance nas Lives</p>
        <div style={{ width: '120px', height: '120px', borderRadius: '50%', overflow: 'hidden', border: '3px solid #39FF14', marginBottom: '15px' }}>
          <img src={obterImagemJogador(nivel)} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Jogador" />
        </div>
        <div style={{ fontSize: '22px', fontWeight: '950', color: '#fff', marginBottom: '5px' }}>Nível {nivel}</div>
        <div style={{ color: '#eee', fontSize: '12px', marginBottom: '15px' }}>Pontos de Carreira: <span style={{ color: '#39FF14', fontWeight: 'bold' }}>{xp} XP</span></div>
        
        <div style={{ background: 'rgba(57, 255, 20, 0.1)', border: '1px dashed #39FF14', borderRadius: '8px', padding: '10px', width: '100%', boxSizing: 'border-box', marginBottom: '15px' }}>
          <div style={{ color: '#39FF14', fontSize: '11px', fontWeight: '900', marginBottom: '6px' }}>PRIVILÉGIO ATUAL:</div>
          <div style={{ color: '#fff', fontSize: '11px', lineHeight: '1.4', textAlign: 'left' }}>
            {nivel >= 1 && nivel <= 10 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={bronzeJogador} style={{ width: '24px', height: '24px', borderRadius: '50%' }} alt="b" />
                <span><strong>Lv. 1 ao 10: Amador (Bronze)</strong> ➔ Braçadeira de bronze com néon verde discreto.</span>
              </div>
            )}
            {nivel >= 11 && nivel <= 20 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={prataJogador} style={{ width: '24px', height: '24px', borderRadius: '50%' }} alt="s" />
                <span><strong>Lv. 11 ao 20: Convocado (Prata)</strong> ➔ Braçadeira de prata com néon rosa e azul gelo.</span>
              </div>
            )}
            {nivel >= 21 && nivel <= 35 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={ouroJogador} style={{ width: '24px', height: '24px', borderRadius: '50%' }} alt="g" />
                <span><strong>Lv. 21 ao 35: Titular (Ouro)</strong> ➔ Braçadeira de ouro puro com reflexos intensos e néon âmbar.</span>
              </div>
            )}
            {nivel >= 36 && nivel <= 50 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={diamanteJogador} style={{ width: '24px', height: '24px', borderRadius: '50%' }} alt="d" />
                <span><strong>Lv. 36 ao 50: Capitão (Diamante)</strong> ➔ Braçadeira com fragmentos de cristal e luz cyan.</span>
              </div>
            )}
            {nivel >= 51 && nivel <= 70 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={campeaoJogador} style={{ width: '24px', height: '24px', borderRadius: '50%' }} alt="c" />
                <span><strong>Lv. 51 ao 70: Lenda (Campeão)</strong> ➔ Braçadeira lendária envolta em chamas néon, faíscas e coroa.</span>
              </div>
            )}
          </div>
        </div>

        <ConquistasFuturas nivelAtual={nivel} tipo="jogador" />

        <button onClick={aoFechar} style={{ background: '#39FF14', color: 'black', border: '2px solid black', borderRadius: '8px', padding: '8px 24px', fontSize: '12px', fontWeight: '950', cursor: 'pointer', boxShadow: '2px 2px 0px black', width: '100%' }}>VOLTAR AO JOGO ⚽</button>
      </div>

      <InfoNiveis isOpen={infoAberta} onClose={() => setInfoAberta(false)} />
    </div>
  );
}




